export const COURSE_PAUSE_REQUEST_TYPE = {
  futureDated: 'FutureDatedPauseRequest',
  backDated: 'BackDatedPauseRequest',
};
